import { useTranslation } from "react-i18next";

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-[520px] md:min-h-[640px] flex flex-col bg-background-50 overflow-hidden">
      {/* Top content area - single column layout */}
      <div className="pt-28 md:pt-36 px-4 md:px-8 max-w-[1440px] mx-auto w-full">
        {/* Title - full width */}
        <h1 className="font-heading text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold leading-[1.1] tracking-tight text-foreground-950">
          HoobuySpreadsheet
          <br />
          <span className="text-foreground-400">2026</span>
        </h1>

        {/* Description + CTA below title */}
        <div className="mt-6 md:mt-8 max-w-2xl">
          <p className="text-base md:text-lg text-foreground-600 leading-relaxed">
            {t("hero.subtitle")}
          </p>
          <div className="flex flex-col sm:flex-row gap-3 mt-6">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 bg-foreground-950 text-background-50 text-sm font-medium rounded-full hover:bg-foreground-800 transition-all duration-200 cursor-pointer whitespace-nowrap group"
            >
              <span>{t("common.hoobuySheet")}</span>
              <i className="ri-arrow-right-up-line text-base group-hover:translate-x-0.5 transition-transform"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 border border-foreground-200 text-foreground-800 text-sm font-medium rounded-full hover:bg-foreground-50 transition-all duration-200 cursor-pointer whitespace-nowrap group"
            >
              <span>{t("common.buyItNow")}</span>
              <i className="ri-arrow-right-line text-base group-hover:translate-x-1 transition-transform"></i>
            </a>
          </div>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-1.5 mt-5 text-sm font-medium text-foreground-700 hover:text-foreground-950 transition-colors cursor-pointer group whitespace-nowrap"
          >
            <span>{t("hero.ctaGuide")}</span>
            <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
          </a>
        </div>
      </div>

      {/* Bottom image container */}
      <div className="flex-1 w-full mt-10 md:mt-12 px-4 md:px-8 max-w-[1440px] mx-auto">
        <div className="w-full h-[240px] sm:h-[300px] md:h-[380px] rounded-2xl md:rounded-3xl overflow-hidden relative">
          <img
            src="https://readdy.ai/api/search-image?query=Artistic%20editorial%20flat%20lay%20composition%20featuring%20an%20array%20of%20premium%20fashion%20products%20including%20cream%20colored%20sneakers%20beige%20knit%20sweaters%20leather%20accessories%20and%20minimalist%20jewelry%20arranged%20with%20dried%20botanical%20elements%20on%20a%20warm%20sand%20colored%20linen%20surface%20soft%20natural%20daylight%20streaming%20from%20upper%20left%20creating%20delicate%20shadows%20clean%20European%20aesthetic%20with%20coral%20sage%20and%20warm%20neutral%20tones%20sophisticated%20product%20photography%20high%20detail&width=1600&height=800&seq=hero-flatlay-v3-2026&orientation=landscape"
            alt="HoobuySpreadsheet - Produtos selecionados"
            title="HoobuySpreadsheet produtos em destaque"
            className="w-full h-full object-cover object-top"
            loading="eager"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
        </div>
      </div>
    </section>
  );
}